import styled from 'styled-components';
import { atomicBlockContainerWidth } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "TableBlockstyle__Container",
  componentId: "sc-1ym50eo-0"
})(["display:flex;justify-content:center;width:", ";margin:auto;"], atomicBlockContainerWidth);
var StyledTable = styled.table.withConfig({
  displayName: "TableBlockstyle__StyledTable",
  componentId: "sc-1ym50eo-1"
})(["width:100%;margin:16px 0;border-collapse:collapse;"]);
var StyledTd = styled.td.withConfig({
  displayName: "TableBlockstyle__StyledTd",
  componentId: "sc-1ym50eo-2"
})(["padding:8px;text-align:center;border:1px solid rgba(0,0,0,0.2);"]);
export { Container, StyledTd, StyledTable };